import React, { useContext, useRef } from "react";
import { Toast } from "primereact/toast";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { cambiarEstado } from "../../../../../API/Finanzas/Retencion/ComprobanteRetencionRequest";

const ListadoComprobantesEnc = ({
  listadoEnc,
  loading,
  setShowDialog,
  selectedDetalle,
  setSelectedDetalle,
  getInfo,
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const cambiarEstadoRetencion = async (data) => {
    if (data?.IdComprobanteRetencionEnc > 0) {
      const filteredSelected = selectedDetalle?.filter((item) => item.IdEstado !== 90 || item.IdEstado !== 92);

      if (filteredSelected?.length) {
        handleCheckboxChange(filteredSelected);
      } else {
        handleCheckboxChange(data);
      }
    }
  };

  const handleCheckboxChange = async (datos) => {
    if (datos) {
      // Asegurar que `datos` sea un array
      const detalles = Array.isArray(datos) ? datos : [datos];
      const idsIngresoDetalle = detalles.map((detalle) => detalle.IdComprobanteRetencionEnc);

      confirmDialog({
        message: `¿Está seguro que desea cambiar el estado de ${
          detalles.length > 1 ? "los comprobantes" : "el comprobante"
        }?`,
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          const datosTem = {
            IdComprobanteRetencionEnc: idsIngresoDetalle,
            IdUserEdit: userAuth.IdUser
          };
          const respuestaDetalles = await cambiarEstado(datosTem);

          toastShow(toast, "success", "Actualizado", "Registros actualizados.");
          getInfo();
        },
        reject: () => {getInfo()},
      });
    }
    setSelectedDetalle([]);
  };

//   const pagarRetencion = async (data) => {
//     if (data?.IdComprobanteRetencionEnc > 0) {
//       const filteredSelected = selectedDetalle?.filter((item) => item.IdEstado !== 90 || item.IdEstado !== 92);

//       if (filteredSelected?.length) {
//         handleCheckboxChangePagar(filteredSelected);
//       } else {
//         handleCheckboxChangePagar(data);
//       }
//     }
//   };

//   const handleCheckboxChangePagar = async (datos) => {
//     if (datos) {
//       // Asegurar que `datos` sea un array
//       const detalles = Array.isArray(datos) ? datos : [datos];
//       const idsIngresoDetalle = detalles.map((detalle) => detalle.IdComprobanteRetencionEnc);

//       confirmDialog({
//         message: `¿Está seguro que desea cambiar el estado de ${
//           detalles.length > 1 ? "los comprobantes" : "el comprobante"
//         }?`,
//         header: "Confirmación",
//         icon: "pi pi-exclamation-triangle",
//         accept: async () => {
//           const datosTem = {
//             IdComprobanteRetencionEnc: idsIngresoDetalle,
//             IdUserEdit: userAuth.IdUser
//           };
//           const respuestaDetalles = await cambiarEstado(datosTem);

//           toastShow(toast, "success", "Actualizado", "Registros actualizados.");
//           getInfo();
//         },
//         reject: () => {getInfo()},
//       });
//     }
//     setSelectedDetalle([]);
//   };

  const columns = [
    {
      field: "IdComprobanteRetencionEnc",
      header: "ID",
      headerEn: "ID",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.IdComprobanteRetencionEnc,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "FechaEmision",
      header: "Fecha Emisión",
      headerEn: "Issue Date",
      className: "small",
      template: "DateTime",
      alignFrozen: "left",
    },
    {
      // ESTADO
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "large",
      body: (rowData) => ({
        ID: rowData.IdEstado,
        Estado: rowData.StatusName,
      }),
      frozen: "frozen",
      alignFrozen: "left",
      Format: "Estado",
    },
    {
      field: "NoComprobanteRetencion",
      header: "No. Retencion",
      headerEn: "No.Retention ",
      className: "medium",
      Format: "Center",
      Sumary: "count",
        onCellDoubleClicked: ({ data }) => {
          console.log(data);
          if(data?.IdComprobanteRetencionEnc){
            setSelectedDetalle([data])
            setShowDialog(true)
          }
        },
    },
    {
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "XXXlarge",
    },
    {
      field: "NombreSucursal",
      header: "Nombre Sucursal",
      headerEn: "Name",
      className: "XXXlarge",
    },
    {
      field: "DescripcionImpuestoRetenido",
      header: "Descripcion Impuesto",
      headerEn: "Tax Description ",
      className: "XXlarge",
    },
    {
      field: "CantidadDetalles",
      header: "Cantidad Facturas",
      headerEn: "Invoice Quantity",
      className: "small",
      Format: "Center",
      Sumary: "sum",
    },
    {
      field: "MontoL",
      header: "Monto L",
      headerEn: "Amount L",
      className: "medium",
      Format: "Currency",
      alignFrozen: "right",
      Sumary: "sum",
    },
    {
      field: "MontoD",
      header: "Monto $",
      headerEn: "Amount $",
      className: "medium",
      Format: "Currency",
      alignFrozen: "right",
      Sumary: "sum",
    },
    {
      field: "Tasa",
      header: "Tasa %",
      headerEn: "Rate",
      className: "Xsmall",
      Format: "Porcentaje",
      alignFrozen: "right",
      Sumary: "sum",
    },
    {
      field: "TotalImporteTotal",
      header: "Importe Total",
      headerEn: "Total Import",
      className: "medium",
      Format: "Currency",
      alignFrozen: "right",
      Sumary: "sum",
    },
    {
      field: "",
      header: "Entregado",
      className: "Xsmall",
      Format: "Template",
      align: "center",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      body: (rowData) =>
        rowData?.IdComprobanteRetencionEnc && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Checkbox
              onChange={(e) => {
                cambiarEstadoRetencion(rowData);
              }}
              disabled={[90, 91, 92].includes(rowData?.IdEstado)}
              checked={rowData.IdEstado === 91 ? true : false}
            />
          </div>
        ),
    },
    // {
    //     field: "",
    //     header: "Acreditado",
    //     className: "Xsmall",
    //     Format: "Template",
    //     align: "center",
    //     frozen: "true",
    //     alignFrozen: "right",
    //     filter: false,
    //     body: (rowData) =>
    //       rowData?.IdComprobanteRetencionEnc && (
    //         <div
    //           style={{
    //             display: "flex",
    //             justifyContent: "center",
    //             alignItems: "center",
    //             height: "100%",
    //           }}
    //         >
    //           <Checkbox
    //             onChange={(e) => {
    //                 pagarRetencion(rowData);
    //             }}
    //           //   disabled={[90, 91, 92].includes(rowData?.IdEstado)}
    //             checked={rowData.Acreditado === true ? true : false}
    //           />
    //         </div>
    //       ),
    // },
    {
      field: "IdRango",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            if(rowData?.IdComprobanteRetencionEnc){
              setSelectedDetalle([rowData])
              setShowDialog(true)
            }
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: listadoEnc,
    loading: loading,
    showModal: (e) => showModal(e),
    selected: selectedDetalle,
    setSelected: (e) => setSelectedDetalle(e),
  };

  const showModal = () => {
    setShowDialog(true);
  };

  return (
    <div>
      <Toast ref={toast} />
      <div style={{ height: "82vh" }}>
        <AgGrid table={table} />
      </div>
    </div>
  );
};

export default ListadoComprobantesEnc;
